import { withTranslation } from 'react-i18next';

import { REVIEW } from '../rule';

/**
 * Block 02's review view: every selected query, or only the ones flagged for a brand or navigation
 * check. It narrows the rows already read, in memory, and each view names how many rows it holds
 * so an empty one says so before it is picked. The flag is a text heuristic, and the note beside
 * the buttons says that rather than letting it pass for a classification.
 */
function ReviewFilter({ t, review, counts, onReview }) {
    return (
        <div className="table-additional-view">
            <div className="table-additional-view-btns">
                <div className="table-additional-view-btn-groups">
                    {Object.values(REVIEW).map((value) => (
                        <button
                            type="button"
                            key={value}
                            className={review === value ? 'active' : ''}
                            aria-pressed={review === value}
                            onClick={() => onReview(value)}
                        >
                            {t(`tools.cannibalization.review.${value}`)} ({counts[value] ?? 0})
                        </button>
                    ))}
                </div>
            </div>

            <span className="gsc-tool-field-note">
                {t('tools.cannibalization.review.heuristic_note')}
            </span>
        </div>
    );
}

export default withTranslation()(ReviewFilter);
